import { Money, formatMoney } from '@betterment/core';
import { HStack, Text, VStack } from '@betterment/samba-react';
import { ReturnsText } from '@betterment/shared-components';

import { DateRangeOption } from '../../../../../../../graphql/schema';
import { timePeriodForValueLabel } from '../../timePeriods';

type DuringMarketHoursType = {
  latestPriceAmount: Money;
  latestReturnsAmount: Money;
  latestReturnsPercentage: number;
  dateRangeOption: DateRangeOption;
};

export const DuringMarketHours = ({
  latestPriceAmount,
  latestReturnsAmount,
  latestReturnsPercentage,
  dateRangeOption,
}: DuringMarketHoursType) => {
  return (
    <VStack>
      <Text color="text" variant="text100">
        Last price
      </Text>
      <Text variant="text400">{formatMoney(latestPriceAmount, 'default')}</Text>
      <HStack css={{ gap: 'space.50', alignItems: 'center' }}>
        <ReturnsText
          variant="text100"
          negativeToken="text.critical"
          amount={latestReturnsAmount}
          percent={latestReturnsPercentage}
        />
        <Text variant="text100" color="text.weak">
          {timePeriodForValueLabel(dateRangeOption)}
        </Text>
      </HStack>
    </VStack>
  );
};
